import { render, staticRenderFns } from "./StudyCard.vue?vue&type=template&id=0547c2b6&scoped=true"
import script from "./StudyCard.vue?vue&type=script&lang=js"
export * from "./StudyCard.vue?vue&type=script&lang=js"
import style0 from "./StudyCard.vue?vue&type=style&index=0&id=0547c2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547c2b6",
  null
  
)

export default component.exports